import { formatLocale } from '@/modules/shared/helpers/locale'

import type { DataPoint } from '@/modules/shared/components/data-point'

export const getDataPointListValues = (dataPoint?: DataPoint): Record<string, any> => {
  const date = dataPoint?.date

  if (!date) {
    return {}
  }

  return {
    date: formatLocale(date, 'dd MMMM yyyy'),
  }
}

export const getMostRecentDataPoint = (dataPoints: DataPoint[]): DataPoint | undefined => {
  return dataPoints.reduce((latest, current) => {
    const currentRecordedDate = current.date ? new Date(current.date) : undefined
    const latestRecordedDate = latest.date ? new Date(latest.date) : undefined
    if (!latestRecordedDate) {
      return current
    }
    if (!currentRecordedDate) {
      return latest
    }
    return currentRecordedDate > latestRecordedDate ? current : latest
  })
}
